export default __webpack_public_path__ + "static/arrows-19f60bfe8e166e201685a76dee73d680.gif";